import React, { useEffect, useState } from 'react';
import { healthsherpa } from './api';
import PersonView from './HealthSherpaPerson';

// =============================================================================
// Health coverage (5.19.0; 5.20.0) — the client's HealthSherpa coverage in the main InsureDocs view (a side
// panel, opened from the client's Profile like Signatures opens its panel). Admins always; others only
// when the HealthSherpa setting status_tab_staff_visible is on (the backend decides).
// 5.20.0: the panel renders the SAME PersonView as the HealthSherpa page's person page (compact): the
// household, the timeline by plan year, the status history with "Show every check".
// =============================================================================

export default function HealthCoveragePanel({ clientId, darkMode, onClose }) {
  const c = {
    panel: darkMode ? '#242424' : '#fff', bg: darkMode ? '#1a1a1a' : '#f5f5f5', border: darkMode ? '#333' : '#e5e5e5',
    text: darkMode ? '#f0f0f0' : '#1a1a1a', sub: darkMode ? '#aab0b8' : '#4f5761',
  };
  const [personId, setPersonId] = useState(undefined);       // undefined = loading, null = none
  const [error, setError] = useState(null);
  useEffect(() => {
    let alive = true;
    setPersonId(undefined); setError(null);
    healthsherpa.policy.clientPerson(clientId)
      .then((r) => { if (alive) setPersonId(r.data.person_id || null); })
      .catch((e) => { if (alive) setError(e?.response?.data?.detail || 'Could not load the health coverage'); });
    return () => { alive = false; };
  }, [clientId]);
  return (
    <div style={{ position: 'fixed', top: 0, right: 0, bottom: 0, width: 640, maxWidth: '96vw', background: c.bg, color: c.text, zIndex: 1100,
      borderLeft: `1px solid ${c.border}`, boxShadow: '-8px 0 24px rgba(0,0,0,0.3)', display: 'flex', flexDirection: 'column' }}
      role="dialog" aria-label="Health coverage">
      <div style={{ padding: '10px 14px', borderBottom: `1px solid ${c.border}`, display: 'flex', alignItems: 'center', gap: 10, background: c.panel }}>
        <div style={{ flex: 1, minWidth: 0, fontSize: 14, fontWeight: 700 }}>🩺 Health coverage</div>
        <button onClick={onClose} style={{ padding: '6px 12px', fontSize: 12, borderRadius: 5, border: `1px solid ${c.border}`, background: c.panel, color: c.text, cursor: 'pointer' }}>Close</button>
      </div>
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {error && <div style={{ color: '#e07070', fontSize: 13, padding: 14 }}>{error}</div>}
        {!error && personId === undefined && <div style={{ fontSize: 12, color: c.sub, padding: 14 }}>Loading…</div>}
        {!error && personId === null && <div style={{ fontSize: 12, color: c.sub, padding: 14 }}>No HealthSherpa applications are linked to this client.</div>}
        {!error && personId && (
          <PersonView personId={personId} darkMode={darkMode} compact
            onChanged={() => setPersonId(null)} />   /* unassigned: no longer this client's */
        )}
      </div>
    </div>
  );
}
